<template>
  <figure :class="`file-icon ${name}-icon`" v-if="!error">
    <InlineSvg :src="`/static/svg/${name}.svg`" @error="error = true" />
  </figure>
</template>

<script>
import InlineSvg from "vue-inline-svg";

export default {
  name: "FileIconComponent",
  props: {
    name: String,
  },
  data() {
    return {
      error: false,
    };
  },
  components: {
    InlineSvg,
  },
};
</script>
